
import { BsBag } from "react-icons/bs";
import {FaShoppingBag} from "react-icons/fa";
import {Animated} from "react-animated-css";

export const CartWidget = ()=> {

    return (
      
        <BsBag color="white" size="1.5rem"/>
        
  
    
    );
  }
  


export const CartWidgetUSe = ()=>{
  return(

 <FaShoppingBag color="white" size="1.5rem"/>

    
    )
}
